import { gql } from "@apollo/client";

export default gql`
  fragment ComplianceProgramMissingAssessment on MissingAssessmentNode {
    responder {
      id
      name
      avatar
    }
    responderId
    responderName
    responderDeactivated
    target {
      id
      name
      avatar
    }
    assessmentTemplate {
      id
      assessmentType
    }
  }
  fragment ComplianceProgramReportParticipantStatusUser on UserNode {
    id
    name
    membershipStatus(organizationId: $organizationId)
    teamsList {
      id
      title
    }
  }
  fragment ComplianceProgramReportParticipantStatus on ParticipantStatusNode {
    isOverdue
    steps {
      key
      step
      status
      dueDate
      overdue
      daysOverdue
      dueAfterStartDays
      blockedReason
      blocked
      blockedLabel
      unblockedBy
      viewerAssessmentId
    }
    oneononeStatus
    performanceAssessmentStatus
    performanceSelfAssessmentStatus
    managerAssessmentStatus
    managerSelfAssessmentStatus
    peerAssessmentStatus
    peerSelfAssessmentStatus
    calibrationStatus
    deliveryStatus
    engagementSurveyStatus
    excused
    excusedReason
    deactivated
    meeting {
      id
      title
      meetingGroupId
    }
    user {
      ...ComplianceProgramReportParticipantStatusUser
      email
      avatar
      managersList {
        id
        name
        avatar
      }
    }
  }

  query getComplianceProgramProgress(
    $complianceProgramId: Int!
    $organizationId: Int!
  ) {
    complianceProgram(pk: $complianceProgramId) {
      id
      title
      created
      updated
      dueDate
      startDate
      periodStartDate
      periodEndDate
      ongoing
      startDateOffset
      startDateDueDateOffset
      startDatePeriodStartOffset
      startDatePeriodEndOffset
      state
      recurrence
      assessmentDeliveries {
        edges {
          node {
            id
            target {
              id
            }
          }
        }
      }
      assessmentsOpenForNominations {
        edges {
          node {
            id
            targetUser {
              ...ComplianceProgramReportParticipantStatusUser
            }
            nominationsCount
          }
        }
      }
      canUpdate {
        permission
        reason
      }
      canDelete {
        permission
        reason
      }
      appliesTo
      appliesToTeams {
        edges {
          node {
            id
            title
          }
        }
      }
      appliesToManagers {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      appliesToUsers {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      excludedUsers {
        edges {
          node {
            id
            name
            avatar
          }
        }
      }
      excludedHireDateAfter
      requiredTopicTemplates {
        edges {
          node {
            id
            title
          }
        }
      }
      performanceAssessmentTemplate {
        id
        assessmentType
        hasSelfAssessment
        isOnlySelfAssessment
        delivery
      }
      engagementSurveyTemplate {
        id
        assessmentType
        hasSelfAssessment
        isOnlySelfAssessment
        delivery
      }
      managerAssessmentTemplate {
        id
        assessmentType
        hasSelfAssessment
        isOnlySelfAssessment
        delivery
      }
      peerAssessmentTemplate {
        id
        assessmentType
        hasSelfAssessment
        isOnlySelfAssessment
        providers
        delivery
      }
      participantStatus {
        edges {
          node {
            ...ComplianceProgramReportParticipantStatus
          }
        }
      }
      usersMissingAssessment {
        edges {
          node {
            ...ComplianceProgramMissingAssessment
          }
        }
      }
    }
  }
`;
